// src/services/StrategyService.ts
import ShareStateService from './ShareStateService';
import { STRATEGY_STORAGE_KEY } from '../components/Strategy/StrategyTypes';

const StrategyService = {
  /**
   * Get all saved strategies from localStorage
   */
  getSavedStrategies(): { [key: string]: string } {
    try {
      const savedStrategiesJSON = localStorage.getItem(STRATEGY_STORAGE_KEY);
      return savedStrategiesJSON ? JSON.parse(savedStrategiesJSON) : {};
    } catch (error) {
      console.error('Failed to get saved strategies:', error);
      return {};
    }
  },

  /**
   * Save a strategy to localStorage
   */
  saveStrategy(name: string): boolean {
    try {
      // Get existing strategies
      const strategies = this.getSavedStrategies();
      
      // Generate the share string for the current state
      const shareString = ShareStateService.createShareableUrl().split('?s=')[1];
      
      // Add the new strategy
      strategies[name] = shareString;
      
      // Save to localStorage
      localStorage.setItem(STRATEGY_STORAGE_KEY, JSON.stringify(strategies));
      
      return true;
    } catch (error) {
      console.error('Failed to save strategy:', error);
      return false;
    }
  },

  /**
   * Delete a strategy from localStorage
   */
  deleteStrategy(name: string): boolean {
    try {
      // Get existing strategies
      const strategies = this.getSavedStrategies();
      
      // Check if the strategy exists
      if (!strategies[name]) {
        console.error(`Strategy with name "${name}" not found`);
        return false;
      }
      
      // Delete the strategy
      delete strategies[name];
      
      // Save to localStorage
      localStorage.setItem(STRATEGY_STORAGE_KEY, JSON.stringify(strategies));
      
      return true;
    } catch (error) {
      console.error('Failed to delete strategy:', error);
      return false;
    }
  },

  /**
   * Load a strategy from a share string
   */
  loadStrategy(shareString: string, strategyVersion?: number): boolean {
    try {
      // Create a temporary URL with the share string
      const urlParams = new URLSearchParams();
      urlParams.set('s', shareString);
      if (strategyVersion !== undefined) {
        urlParams.set('sv', strategyVersion.toString());
      }
      window.history.pushState(null, '', `?${urlParams.toString()}`);
      
      // Load the state
      const result = ShareStateService.loadSharedState();
      
      return result;
    } catch (error) {
      console.error('Failed to load strategy:', error);
      return false;
    }
  }
};

export default StrategyService;